import React from 'react';
import { defaultTemplate } from 'core/hoc';
import { BaasicInput } from 'core/components';
import { translate } from 'core/utils';

function UpdateProductModalContentTemplate({ updateProductPartModalContentViewStore, t }) {
	const { updateProductPartForm } = updateProductPartModalContentViewStore;
	return (
		<form className="ReactModal__form" onSubmit={updateProductPartForm.onSubmit}>
			<div className="ReactModal__header">
				<h3 className="spc--bottom--sml">{t('PRODUCTDETAILVIEW.UPDATEPRODUCTPARTMODAL.UPDATEPRODUCTPART')}</h3>
			</div>
			<div className="ReactModal__body">
				<BaasicInput field={updateProductPartForm.$('quantity')} showCheckmark={false} />
				{updateProductPartForm.error && (
					<div>
						<p className="type--color--warning spc--bottom--sml">{translate(updateProductPartForm.error)}</p>
					</div>
				)}
			</div>
			<div className="ReactModal__footer">
				<button className="btn btn--med btn--primary spc--bottom--sml" type="submit">
					{t('SAVE')}
				</button>
			</div>
		</form>
	);
}

export default defaultTemplate(UpdateProductModalContentTemplate);
